"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _states = _interopRequireDefault(require("../addresses/states"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = {
  // Alabama
  alnb: {
    state: _states["default"].AL,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }, {
      name: 'Tax Documents'
    }],
    guide: null
  },
  almb: {
    state: _states["default"].AL,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records',
      mandatory: true
    }, {
      name: 'Payment Advices for Debtor',
      mandatory: true
    }, {
      name: 'Statement Under Penalty of Perjury Concerning Payment Advices Due Pursuant to 11 U.S.C. § 521(a)(1)(B)(iv)',
      url: 'https://www.almb.uscourts.gov/sites/almb/files/statement_payment_advices.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Middle District of Alabama Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Alabama called the Statement Under Penalty of Perjury Concerning Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  alsb: {
    state: _states["default"].AL,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Submission of Payment Advices for Trustee'
    }, {
      name: 'Submission of Tax Documents for Trustee'
    }],
    guide: null
  },
  // Alaska
  akb: {
    state: _states["default"].AK,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Arkansas
  arb: {
    state: _states["default"].AR,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Arizona
  azb: {
    state: _states["default"].AZ,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Pro Se Declaration',
      url: 'http://www.azb.uscourts.gov/sites/default/files/Form%201007-3%20Declaration%20Under%20Penalty%20of%20Perjury%20by%20Pro%20Se%20Debtor%20-%20Post.pdf',
      mandatory: true
    }, {
      name: 'Declaration of Evidence of Employer Payments',
      url: 'http://www.azb.uscourts.gov/sites/default/files/Form%201007-2%20Declaration%20of%20Evidence%20of%20Payments.docx',
      mandatory: true
    }],
    guide: null
  },
  // California
  canb: {
    state: _states["default"].CA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  caeb: {
    state: _states["default"].CA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  cacb: {
    state: _states["default"].CA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement of Related Cases (LBR Form 1015-2.1)',
      url: 'http://www.cacb.uscourts.gov/sites/cacb/files/documents/forms/F1015-2.1STMTRELATEDCASES.pdf',
      mandatory: true
    }, {
      name: 'Declaration by Debtor as to Whether Db Received Income From an Employer (LBR Form F1002-1)',
      url: 'http://www.cacb.uscourts.gov/sites/cacb/files/documents/forms/F1002-1.EMPINCOMEDEC.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Central District of California Bankruptcy Court requires you to file two local bankruptcy forms for California. First, you must file the Declaration by Debtor as to Whether Income Was Received. On this local form, you certify that you are attaching all your pay stubs for the 60-day period before your filing date or you must explain the reason why you don’t have pay stubs, such as “I was unemployed.” Second, you must file the Statement of Related Cases, which asks about past bankruptcy filings by you, your spouse, or your business partner.'
  },
  casb: {
    state: _states["default"].CA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Colorado
  cob: {
    state: _states["default"].CO,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: true,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Pay Advice/Income Record and/or Statement Concerning No Employee Income Record'
    }, {
      name: 'Statement Concerning Payment Advices ',
      url: 'https://www.cob.uscourts.gov/sites/default/files/forms/1007-6.1.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Colorado Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Colorado called the Statement Concerning Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Conneticut
  ctb: {
    state: _states["default"].CT,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: ['online'],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Delaware
  deb: {
    state: _states["default"].DE,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // District of Columbia
  dcb: {
    state: _states["default"].DC,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'LBR 1007-5 Declaration of Debtor Regarding Payment Advices',
      url: 'http://www.dcb.uscourts.gov/sites/dcb/files/Local_Form_9.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Columbia Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Washington, D.C. called the Declaration of Debtor Regarding Payment Advices. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Florida
  flnb: {
    state: _states["default"].FL,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  flmb: {
    state: _states["default"].FL,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: true,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement of No Payment Advices'
    }],
    guide: null
  },
  flsb: {
    state: _states["default"].FL,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Declaration Regarding Payment Advices',
      url: 'http://www.flsb.uscourts.gov/sites/flsb/files/documents/forms/Declaration_Regarding_Payment_Advices_%28LF-10%29.docx',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Florida Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local Florida called the Declaration Regarding Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Georgia
  ganb: {
    state: _states["default"].GA,
    payStubsFiled: true,
    reopenInstructions: 'Motion to reopen can be filed in response to dismissal order. If filed within 14 days $260 not charged.',
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement Regarding Payment Advices',
      url: 'http://www.ganb.uscourts.gov/sites/default/files/Statement%20Regarding%20Pay%20Advices.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Northern District of Georgia Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Georgia called the Statement Regarding Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  gamb: {
    state: _states["default"].GA,
    payStubsFiled: true,
    reopenInstructions: 'Motion to reopen can be filed in response to dismissal order. If filed within 14 days $260 not charged.',
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records (or Affidavit of No Income)'
    }],
    guide: null
  },
  gasb: {
    state: _states["default"].GA,
    payStubsFiled: true,
    reopenInstructions: 'Motion to reopen can be filed in response to dismissal order. If filed within 14 days $260 not charged.',
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Transmittal of Pay Advices',
      url: 'http://www.gasb.uscourts.gov/sites/gasb/files/TransmittalPayAdvices_Dec17.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Georgia Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Georgia called the Transmittal of Pay Advices form. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Hawaii
  hib: {
    state: _states["default"].HI,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Idaho
  idb: {
    state: _states["default"].ID,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement of Domestic Support Obligations',
      url: 'https://www.id.uscourts.gov/Content_Fetcher/index.cfml/Stmt_of_Domestic_Support_Debtor_Only_657.pdf?Content_ID=657',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Idaho Bankruptcy Court requires you to file a local free bankruptcy forms for Idaho called the Statement of Domestic Support Obligations. On this form, you tell the Court whether you owe any domestic support obligations like child support or alimony.'
  },
  // Illinois
  ilnb: {
    state: _states["default"].IL,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  ilcb: {
    state: _states["default"].IL,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  ilsb: {
    state: _states["default"].IL,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Indiana
  innb: {
    state: _states["default"].IN,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  insb: {
    state: _states["default"].IN,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Pay Advices and/or Statement in Lieu of Pay Advices'
    }, {
      name: 'Pay Advices or Statement in Lieu for Non-Filing Spouse'
    }],
    guide: null
  },
  // Iowa
  ianb: {
    state: _states["default"].IA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  iasb: {
    state: _states["default"].IA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Record'
    }, {
      name: 'Declaration of Debtor Regarding No Evidence of Any Payment Recieved from Any Employer',
      url: 'https://www.iasb.uscourts.gov/sites/iasb/files/DeclarationNoIncome.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Iowa Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Iowa called the Declaration of Debtor Regarding No Evidence of Any Payment Recieved from Any Employer. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Kansas
  ksb: {
    state: _states["default"].KS,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records',
      url: 'http://www.ksb.uscourts.gov/sites/ksb/files/pmt_advice_form.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Kansas Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Kansas called the Declaration Regarding Payment Advices. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Kentucky
  kyeb: {
    state: _states["default"].KY,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }],
    guide: null
  },
  kywb: {
    state: _states["default"].KY,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Louisiana
  laeb: {
    state: _states["default"].LA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices'
    }],
    guide: null
  },
  lamb: {
    state: _states["default"].LA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  lawb: {
    state: _states["default"].LA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }],
    guide: null
  },
  // Maine
  meb: {
    state: _states["default"].ME,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford.',
    forms: [],
    guide: null
  },
  // Maryland
  mdb: {
    state: _states["default"].MD,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Massachusetts
  mab: {
    state: _states["default"].MA,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Michigan
  mieb: {
    state: _states["default"].MI,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  miwb: {
    state: _states["default"].MI,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Asset Protection Report',
      url: 'http://www.miwb.uscourts.gov/sites/miwb/files/forms/2012-asset-protection.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Western District of Michigan Bankruptcy Court requires you to file a local free bankruptcy forms for Michigan called the Asset Protection Report. On this form, you list any property serving as collateral for a secured debt on Schedule D, any property relating to a lease or executory contract on Schedule G, and any insurable asset on Schedule A/B in which there is non-exempt equity.'
  },
  // Minnesota
  mnb: {
    state: _states["default"].MN,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices',
      url: 'http://www.mnb.uscourts.gov/sites/mnb/files/local_form_payment_advices.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Minnesota Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local Minnesota called the Payment Advices Cover Sheet. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Mississippi
  msnb: {
    state: _states["default"].MS,
    payStubsFiled: false,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford.',
    forms: [],
    guide: null
  },
  mssb: {
    state: _states["default"].MS,
    payStubsFiled: false,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }],
    guide: null
  },
  // Missouri
  moeb: {
    state: _states["default"].MO,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  mowb: {
    state: _states["default"].MO,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Debtor Evidence of No Employer Payments',
      url: 'http://www.mow.uscourts.gov/sites/mow/files/BK_Debtors_Evidence_of_No_Employer_Payments.pdf',
      mandatory: true
    }, {
      name: 'Affidavit re: NO Tax Returns'
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Western District of Missouri Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local bankruptcy form for Missouri called Debtor Evidence of No Employer Payments. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Montana
  mtb: {
    state: _states["default"].MT,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Nebraska
  neb: {
    state: _states["default"].NE,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Nevada
  nvb: {
    state: _states["default"].NV,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: true,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // New Hampshire
  nhb: {
    state: _states["default"].NH,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // New Jersey
  njb: {
    state: _states["default"].NJ,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Everyone except Ford allows generally.',
    forms: [],
    guide: null
  },
  // New Mexico
  nmb: {
    state: _states["default"].NM,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // New York
  nynb: {
    state: _states["default"].NY,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  nysb: {
    state: _states["default"].NY,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 4,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  nyeb: {
    state: _states["default"].NY,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 4,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Pay Advices Sheet'
    }, {
      name: 'Statement of Related Cases',
      url: 'http://www.nyeb.uscourts.gov/sites/nyeb/files/forms/usbc-2_1.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Eastern District of New York Bankruptcy Court requires you to file two local free bankruptcy forms for New York.  First, you must file the Pay Advices Cover Sheet. On this local form, you certify that you are attaching all your pay stubs for the 60-day period before your filing date or you must explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.” Second, you must file the Statement of Related Cases, which asks about past bankruptcy filings by you, your spouse, or your business partner.'
  },
  nywb: {
    state: _states["default"].NY,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // North Carolina
  nceb: {
    state: _states["default"].NC,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  ncmb: {
    state: _states["default"].NC,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  ncwb: {
    state: _states["default"].NC,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // North Dakota
  ndb: {
    state: _states["default"].ND,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Statement Under Penalty of Perjury Concerning Payment Advices',
      url: 'http://www.ndb.uscourts.gov/sites/default/files/forms/statement_concerning_payment_advices.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of North Dakota Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for North Dakota called the Statement Concerning Payment Advices. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Ohio
  ohnb: {
    state: _states["default"].OH,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Declaration Under Penalty of Perjury; Employee Income Records'
    }],
    guide: null
  },
  ohsb: {
    state: _states["default"].OH,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Statement of Related Cases',
      url: 'https://www.ohsb.uscourts.gov/pdffiles/LBR%20Form%201015-2.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Ohio Bankruptcy Court requires you to file a local free bankruptcy forms for Ohio. You must file the Statement of Related Cases, which asks about past bankruptcy filings by you, your spouse, or your business partner.'
  },
  // Oklahoma
  oknb: {
    state: _states["default"].OK,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices Certification',
      url: 'http://www.oknb.uscourts.gov/sites/default/files/forms/LF10071F.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Northern District of Oklahoma Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Oklahoma called the Payment Advices Certification. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  okeb: {
    state: _states["default"].OK,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  okwb: {
    state: _states["default"].OK,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Pay Advice Cover Sheet',
      url: 'http://www.okwb.uscourts.gov/sites/okwb/files/Pay_Advice_Cover_Sheet_Fillable.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Western District of Oklahoma Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Oklahoma called the Pay Advice Cover Sheet. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Oregon
  orb: {
    state: _states["default"].OR,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: true,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Pennsylvania
  paeb: {
    state: _states["default"].PA,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 2,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }, {
      name: 'Pro Se Statement',
      url: 'http://www.paeb.uscourts.gov/sites/paeb/files/Local%20Bankruptcy%20Forms%20-L.B.F.%202016-4.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Eastern District of Pennsylvania Bankruptcy Court requires you to file a Pro Se Statement if you are filing without a lawyer. The purpose of this form is to tell the Court whether you have been assisted by a for-profit bankruptcy petition preparer. Petition Preparers must follow special rules set by the Court.'
  },
  pamb: {
    state: _states["default"].PA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices'
    }, {
      name: 'Certification of No Payment Advices',
      url: 'http://www.pamb.uscourts.gov/sites/default/files/forms/USBC_PAMB_LBF_1007-1c.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Middle District of Pennsylvania Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Pennsylvania called the Certification of No Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  pawb: {
    state: _states["default"].PA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: true,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Puerto Rico
  prb: {
    state: _states["default"].PR,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Rhode Island
  rib: {
    state: _states["default"].RI,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices'
    }],
    guide: null
  },
  // South Carolina
  scb: {
    state: _states["default"].SC,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: true,
    petitionMailed: null,
    rideThrough: 'Allowed',
    forms: [{
      name: 'Payment Advices'
    }],
    guide: null
  },
  // South Dakota
  sdb: {
    state: _states["default"].SD,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement Regarding Payment Advices',
      url: 'http://www.sdb.uscourts.gov/sites/sdb/files/forms/Appendix%201B.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of South Dakota Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for South Dakota called the Statement Regarding Payment Advices. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Tennessee
  tneb: {
    state: _states["default"].TN,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: null,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Statement Regarding Payment Advices',
      url: 'http://www.tneb.uscourts.gov/sites/default/files/1007-1.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Eastern District of Tennessee Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Tennessee called the Statement Regarding Payment Advices. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  tnmb: {
    state: _states["default"].TN,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }],
    guide: null
  },
  tnwb: {
    state: _states["default"].TN,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Texas
  txnb: {
    state: _states["default"].TX,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }],
    guide: null
  },
  txsb: {
    state: _states["default"].TX,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 2,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Pay Advices or Certification'
    }, {
      name: 'No Payment Advices Certification',
      url: 'http://www.txs.uscourts.gov/sites/txs/files/payadvcert.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Texas Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for Texas called the No Payment Advices Certification. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  txeb: {
    state: _states["default"].TX,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Employee Income Records'
    }, {
      name: 'Notice to Individual Consumer Debtor (Sec. 342(b))'
    }],
    guide: null
  },
  txwb: {
    state: _states["default"].TX,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Payment Advices'
    }, {
      name: 'Pro Se Questionnaire',
      url: 'http://www.txwb.uscourts.gov/sites/txwb/files/prose_questionnaire-fillable.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Western District of Texas Bankruptcy Court requires you to file a Pro Se Questionnaire if you are filing without a lawyer. The purpose of this form is to tell the Court whether you have been assisted by a for-profit bankruptcy petition preparer. Petition Preparers must follow special rules set by the Court.'
  },
  // Utah
  utb: {
    state: _states["default"].UT,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [{
      name: 'Declaration Re: Tax Returns'
    }, {
      name: 'Payment Advices Certification',
      url: 'https://www.utb.uscourts.gov/sites/default/files/forms/payment_advices_cert_writeable.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the District of Utah Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Utah called the Payment Advices Certification. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Vermont
  vtb: {
    state: _states["default"].VT,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: ['moneyOrder', 'bankCheck'],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Virginia
  vaeb: {
    state: _states["default"].VA,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  vawb: {
    state: _states["default"].VA,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // Washington
  waeb: {
    state: _states["default"].WA,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  wawb: {
    state: _states["default"].WA,
    payStubsFiled: null,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: null,
    forms: [],
    guide: null
  },
  // West Virgina
  wvnb: {
    state: _states["default"].WV,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford & some smaller lenders.',
    forms: [],
    guide: null
  },
  wvsb: {
    state: _states["default"].WV,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford & some smaller lenders.',
    forms: [{
      name: 'Pay Stubs'
    }, {
      name: 'Statement in Lieu of Payment Advices',
      url: 'http://www.wvsb.uscourts.gov/sites/wvsb/files/forms/payadvice_0_0.pdf',
      mandatory: true
    }, {
      name: 'Statement Regarding Tax Returns',
      url: 'http://www.wvsb.uscourts.gov/sites/wvsb/files/forms/taxstate.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Southern District of Texas Bankruptcy Court requires you to file your pay stubs for the 60-day period before filing. If you don’t have pay stubs for that period, you must file a local free bankruptcy forms for West Virginia called the Statement in Lieu of Payment Advices. On this local form, you explain the reason you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Wisconsin
  wieb: {
    state: _states["default"].WI,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford & some smaller lenders.',
    forms: [{
      name: 'Pay Advice Cover Sheet',
      url: 'https://www.wieb.uscourts.gov/sites/default/files/forms/Pay%20Advice%20Cover%20Sheet-2.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Eastern District of Wisconsin Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Wisconsin called the Pay Advice Cover Sheet. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  wiwb: {
    state: _states["default"].WI,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford & some smaller lenders.',
    forms: [{
      name: 'Employee Income Records / Payment Advices for Debtor'
    }, {
      name: 'Pay Advice Cover Sheet',
      url: 'http://www.wiwb.uscourts.gov/sites/wiwb/files/payment_advices_cover_sheet.pdf',
      mandatory: true
    }],
    guide: 'In addition to the national bankruptcy forms described above, the Western District of Wisconsin Bankruptcy Court requires you to file your pay stubs for the 60-day period before your filing date. Along with your pay stubs, you must file a special local free bankruptcy forms for Wisconsin called the Payment Advices Cover Sheet. On this local form, you certify that you have attached all your pay stubs for the 60-day period or you explain the reason why you don’t have pay stubs, such as “I was unemployed” or “I am self-employed and don’t receive pay stubs.”'
  },
  // Wyoming
  wyb: {
    state: _states["default"].WY,
    payStubsFiled: true,
    reopenInstructions: null,
    paymentMethods: [],
    copiesNumber: 1,
    copiesKeep: true,
    creditorMatrixBlockCap: null,
    creditorMatrixTxtExpected: null,
    petitionMailed: null,
    rideThrough: 'Allowed except Ford & some smaller lenders.',
    forms: [],
    guide: null
  }
};
exports["default"] = _default;